import { useLazyQuery, useQuery } from "@apollo/client/react"; import { useEffect, useState, useRef } from "react";
import { GET_VISITAS, parseVisitas } from "../../../data/graphQL/queries/MisVisitas/getMisVisitas";
import toast from "react-hot-toast";
import { GET_PROFESIONAL_LOGGED } from "../../../data/graphQL/queries/MisVisitas/getProfesionalLogged";
import moment from "moment";

export const useGetRows = (idEvaluacion,
  idPaciente,
  misVisitas,
  fechaDesde,
  fechaHasta,
  idFrecuencia,
  idProfesional,
  idProfesionalSelected,
  idTipoProfesional,
  idTipoProfesionalSelected,
  idFiguraProfesional,
  idFiguraProfesionalSelected,
  figuraProfesionalSelected,
  figuraProfesional
  ) => {
  const [rows, setRows] = useState([]);

  const { data: profesionalLogged } = useQuery(GET_PROFESIONAL_LOGGED, {
    fetchPolicy: 'no-cache',
  });
  const [getVisitas, { data: dataVisitas, loading }] = useLazyQuery(GET_VISITAS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataVisitas) return;
    let dataAdapted = parseVisitas(dataVisitas?.visitas || []);
    const tipoProfesionalValue = misVisitas ? idTipoProfesional : idTipoProfesionalSelected;
    const figuraProfesionalValue = misVisitas ? idFiguraProfesional : idFiguraProfesionalSelected;
    const figuraProfesionalDescValue = misVisitas ? figuraProfesional : figuraProfesionalSelected;
    dataAdapted = dataAdapted.map((item) => ({
      ...item,
      idTipoProfesional: item.idTipoProfesional ?? tipoProfesionalValue,
      idFiguraProfesional: item.idFiguraProfesional ?? figuraProfesionalValue,
      figuraProfesional: item.figuraProfesional ?? figuraProfesionalDescValue
    }));
    setRows(dataAdapted);
  }, [dataVisitas]);


  const profesionalLoggedRef = useRef(profesionalLogged);
  useEffect(() => {
    profesionalLoggedRef.current = profesionalLogged;
  }, [profesionalLogged]);

  const handleSearch = () => {
    const idProf = misVisitas
      ? profesionalLoggedRef.current?.profesionalByIdUsuario?.idProfesional
      : idProfesionalSelected;

    if (!idProf) return;

    getVisitas({
      variables: {
        input: {
          idEvaluacion: idEvaluacion,
          idProfesional: idProf,
          fechaDesde: fechaDesde,
          fechaHasta: moment(fechaHasta).set({ hour: 23, minute: 59, second: 59, millisecond: 49}).format('YYYY-MM-DD HH:mm:ss'),
          idFrecuencia: idFrecuencia,
          idTipoProfesional: idTipoProfesional,
          idFiguraProfesional: idFiguraProfesional
        }
      }
    });
  };

  useEffect(() => {
    if (isNaN(idEvaluacion) || idEvaluacion === null) {
      setRows([]);
      toast.error('Error al dirigirse al contrato.');
    } else if (!misVisitas && (isNaN(idProfesionalSelected) || idProfesionalSelected === null)) {
      setRows([]);
      toast.error('Debe seleccionar un profesional.');
    } else
      handleSearch();
  }, [misVisitas, idEvaluacion, profesionalLogged, idProfesionalSelected, fechaDesde, fechaHasta, idFrecuencia, idTipoProfesional, idFiguraProfesional]);

  return {
    rows,
    setRows,
    loading,
    totalCount: rows.length || 0,
    handleSearch
  };
};